import cryptoRandomString from 'crypto-random-string';

export default {
  methods: {
    generateBasicUniqId: function(){
      
      return cryptoRandomString({length: 6});
      
    }
  }
}